export default __webpack_public_path__ + "static/media/intro-img-yeti.68e32276.png";